// File: /js/shared/handlers/handleAjaxClick.js
import { buildContext } from '/js/shared/context/requestContext.js';
import { ajaxAction }   from '/js/shared/ajax/ajaxAction.js';

export function handleAjaxClick(event) {
  const el = event.target.closest('[data-ajax-click="true"]');
  if (!el || !el.dataset.name) return;

  // Optional confirm-before-dispatch gate. When the button carries
  // `data-confirm-message="…"`, prompt the user with that exact text;
  // cancel aborts the AJAX call. Replaces the pre-CSP inline
  // `onclick="return confirm(…)"` idiom. PHP-side renderers emit the
  // localised string into the attribute (already escaped at render
  // time via htmlspecialchars / Translator::esc) so this stays a
  // pure presentation read.
  const confirmMessage = el.dataset.confirmMessage;
  if (confirmMessage && !window.confirm(confirmMessage)) return;

  // `buildContext(el)` walks ancestors for `[data-scope-hash]` and
  // applies it as the hash override (used by embedded social-card
  // editors). `el.dataset` then wins — explicit `data-hash` on the
  // click target overrides both URL and scope-hash.
  const data = {
    ...buildContext(el),
    ...el.dataset
  };

  // Capture the closest `[data-block-name]` section SYNCHRONOUSLY at
  // click time, starting the walk from `el.parentElement` — NEVER from
  // `el` itself. Two intertwined reasons this is load-bearing:
  //
  //  1. Proxy buttons created by `dispatchProxyClick` (blockEventBus.js)
  //     carry `data-block-name` as part of their AJAX payload — every
  //     edit-mode add / delete / reorder / media-reset goes through one
  //     of these. `Element.closest()` checks the element itself first,
  //     so `el.closest('[data-block-name]')` would return the proxy.
  //  2. The proxy is detached from the DOM synchronously after dispatch.
  //     A scopeEl pointing at the detached proxy can't reach the real
  //     section it was inside — `proxy.querySelector('.blocks-container')`
  //     returns null and `ajaxAction` skips the append, breaking every
  //     dynamic-block insert across the project.
  //
  // Starting from `parentElement` skips `el` and walks the real ancestry.
  // Real `data-ajax-click` buttons (e.g. "+ Ajouter une carte") still
  // resolve correctly: their parent is a wrapper that's one or two
  // levels below the actual `[data-block-name]` element.
  const startEl = el.parentElement ?? el;
  const scopeEl = startEl.closest('[data-block-name]') ?? el;

  ajaxAction(data, true, scopeEl);
}

